import { LoopWinsComponent } from "ags/components/loop-wins-component";
import { AgsLoopWins } from "ags/state-machine/states/ags-loop-wins";
import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
// import { ThemeFreespinsTrailResult } from "integration/results/theme-freespins-trail-result";

export class ThemeLoopWinsState extends AgsLoopWins {
    public onEnter(): void {
        let celebrationContract = Components.get(LoopWinsComponent).start();
        // this.cancelGroup.add(celebrationContract);
        celebrationContract.then(() => this.complete());

        const gameplay: Gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();
    }
    public onSkip() {
        super.onSkip();
        Layers.get("CelebrationContent").defaultScene().execute();
    }
}
